import React, { PureComponent } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, EffectCoverflow } from 'swiper';

import 'swiper/swiper-bundle.css';
import './Interviews.scss';

SwiperCore.use([Navigation, EffectCoverflow]);

const interviews = [
  {
    name: "Marc",
    job: "Consultant indépendant en Achats & Supply",
    video: "/media/Marc%20-%20Consultant%20Ind%C3%A9pendant%20en%20Achats%20&%20Supply.mp4"
  },
  {
    name: "Sandrine",
    job: "Freelance en Ingénierie",
    video: "/media/Sandrine%20-%20Freelance%20en%20Ing%C3%A9nierie.mp4"
  },
  {
    name: "Laurent",
    job: "Consultant en Achats",
    video: "/media/Laurent%20-%20Consultant%20en%20Achats.mp4"
  },
  {
    name: "Ludovic",
    job: "Auto-entrepreneur en Achats",
    video: "/media/Ludovic%20-%20Autoentrepreneur%20en%20Achats.mp4"
  },
];

export default class Interviews extends PureComponent {
  swiperRef = React.createRef();

  handleSlideChange = () => {
    const videos = document.querySelectorAll('.swiper-interviews video');
    videos.forEach(video => {
      video.pause();
    });
  };

  render() {
    return (
      <section className="swiper-interviews">
        <Swiper
          modules={[EffectCoverflow, Navigation]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slidesPerView="auto"
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
          }}
          navigation={true}
          onSlideChange={this.handleSlideChange}
          ref={this.swiperRef}
        >
          {interviews.map((interview, index) => (
            <SwiperSlide key={index}>
              <video controls disablePictureInPicture controlsList="nodownload">
                <source src={interview.video} type="video/mp4" />
              </video>

              <div>
                <strong>{ interview.name }</strong>
                <span>{ interview.job }</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    );
  }
}
